namespace e5 {
    export class ScrollbarScrollView extends Scrollbar {
        private _view: ScrollView = null;
        private _update:() => void;

        constructor(view: ScrollView = null, horizontal: boolean = false) {
            super(horizontal)

            this._update = () => this.update();
            this.view = view;
        }

        private addListener(): void {
            this._view.onResize.add(this._update, this);
            this._view.onTransform.add(this._update, this);
        }

        private removeListener(): void {
            this._view.onResize.remove(this._update, this);
            this._view.onTransform.remove(this._update, this);
        }

        protected getPosition(): ScrollbarData {
            if (!this._view)
                return null;
            return {
                scrollLeft: -this._view.x,
                scrollTop: -this._view.y,
                offsetWidth: this._view.width,
                clientHeight: this._view.height,
                scrollWidth: this._view.contentWidth * this._view.scale,
                scrollHeight: this._view.contentHeight * this._view.scale,
            };
        }

        private get view(): ScrollView {
            return this._view;
        }

        private set view(view: ScrollView) {
            if (this._view === view)
                return;
            if (this._view) {
                this.removeListener();
            }
            this._view = view;
            if (this._view) {
                this.addListener();
                this.update();
            }
        }
    }
}